const isFetchBaseQueryError = response => {
	return response.status === 200;
};

export default isFetchBaseQueryError;
